const REF_KEY = 'culineer_ref'
const REF_TTL_MS = 30 * 24 * 60 * 60 * 1000 // 30 days

export function buildShareUrl(
  path: string,
  contentType: string,
  contentId: string | number,
  refSlug?: string | null
): string {
  const envBase = process.env.NEXT_PUBLIC_APP_URL?.trim()
  const base =
    envBase ||
    (typeof window !== 'undefined' ? window.location.origin : 'https://culineerapp.com')
  const url = new URL(path, base)
  if (refSlug) url.searchParams.set('ref', refSlug)
  url.searchParams.set('utm_source', 'culineer')
  url.searchParams.set('utm_medium', 'share')
  url.searchParams.set('utm_campaign', contentType)
  url.searchParams.set('utm_content', String(contentId))
  return url.toString()
}

export function storeRef(slug: string): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(REF_KEY, JSON.stringify({ ref: slug, expires: Date.now() + REF_TTL_MS }))
}

export function getStoredRef(): string | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = localStorage.getItem(REF_KEY)
    if (!raw) return null
    const entry = JSON.parse(raw)
    if (Date.now() > entry.expires) {
      localStorage.removeItem(REF_KEY)
      return null
    }
    return entry.ref as string
  } catch {
    return null
  }
}

export function clearStoredRef(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem(REF_KEY)
}
